webpackJsonp([3],{

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_login__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_verify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_login__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mini_tabs_mini_tabs__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Russel__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Russel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_Russel__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      searchObj: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_Russel__["Search2objFilter"])(location.search),
      loginTypes: [{ name: '密码登录', value: 'password' }, { name: '验证码登录', value: 'code' }],
      loginType: 'password',
      csrfToken: ''
    };
  },

  computed: {
    formInvalid: function formInvalid() {
      switch (this.loginType) {
        case 'password':
          return this.getFormInvalid(['phone', 'password', 'protocol']);
        case 'code':
          return this.getFormInvalid(['phone', 'code', 'protocol']);
        default:
          return !1;
      }
    },
    isDev: function isDev() {
      return !location.href.match(/^https?:\/\/(www\.|cloud\.)?qingchengfit\.cn.*$/);
    },
    appId: function appId() {
      return this.isDev ? 'wxf27c0fa3622acc79' : 'wx9ee866b4f96f8334';
    },
    redirectUri: function redirectUri() {
      var query = {
        next: this.searchObj.next || this.config.next
      };
      return location.protocol + '//' + (this.isDev ? 'cloudtest' : 'cloud') + '.qingchengfit.cn/api/web/wechat/callback/?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_Russel__["Obj2searchFilter"])(query);
    },
    weixinQuery: function weixinQuery() {
      return {
        appid: this.appId,
        redirectUri: this.redirectUri,
        response_type: 'code',
        scope: 'snsapi_login',
        state: this.csrfToken
      };
    },
    weixinUri: function weixinUri() {
      return 'https://open.weixin.qq.com/connect/qrconnect?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_Russel__["Obj2searchFilter"])(this.weixinQuery) + '#wechat_redirect';
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (this.formInvalid || this.submitting) return !1;
      var data = {
        area_code: this.area,
        phone: this.phone,
        has_read_agreement: !0
      };

      if (this.loginType === 'code') {
        data.code = this.code;
      } else {
        data.password = this.password;
      }

      this.submitting = !0;
      __WEBPACK_IMPORTED_MODULE_2__services_login__["a" /* default */].login(this.config.loginReq, {}, data).then(function () {
        location.href = _this.searchObj.next || _this.config.next;
        _this.submitting = !1;
      }).catch(function (msg) {
        _this.submitting = !1;
        alert(msg);
      });
      return !0;
    }
  },
  components: {
    MiniTabs: __WEBPACK_IMPORTED_MODULE_3__components_mini_tabs_mini_tabs__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_verify__["a" /* default */]],
  created: function created() {},
  mounted: function mounted() {
    try {
      this.csrfToken = document.getElementsByName('csrfmiddlewaretoken')[0].value;
    } catch (e) {
      console.warn(e);
    }
  }
});

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AREAS; });


var AREAS = [{ name: '中国 +86', value: '+86', regex: /^1\d{10}$/ }, { name: '中国台湾 +886', value: '+886', regex: /^09\d{8}$/ }, { name: '美国 +1', value: '+1', regex: /^\d{10}$/ }];

/* harmony default export */ __webpack_exports__["b"] = ({
  common: {
    title: '青橙健身房管理系统',
    logo: 'http://img.qingchengfit.cn/771d7629d9a02c67378da5334ac6c30c.png',
    checkReq: '/api/user/check/',
    checkBindingReq: '/api/web/wechat/check/bind/',
    loginReq: '/api/user/login/',
    resetReq: '/api/staffs/reset/password/',
    registerReq: '/api/user/register/',
    bindReq: '/api/web/wechat/bind/',
    protocolReq: '/api/user/check/read_agreement/',
    next: '/backend/settings/'
  },
  fair: {
    title: '青橙专场招聘会管理系统',
    next: '/fair/admin/'
  },
  competition: {
    title: '青橙赛事训练营管理系统',
    next: '/competition/system/'
  },
  meeting: {
    title: '青橙会议/培训报名管理系统',
    checkReq: '/api/user/check/',
    loginReq: '/api/user/login/',
    next: 'http://meeting.qingchengfit.cn/settings'
  },
  clear: {
    title: '',
    checkReq: '/api/user/check/',
    loginReq: '/api/user/login/'
  }
});

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c40149d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(324);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(243)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c40149d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pages/login.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c40149d6", Component.options)
  } else {
    hotAPI.reload("data-v-c40149d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_login_forms_selects__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_back_home_back_home__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_login__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_login__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Russel__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Russel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_Russel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selects: __WEBPACK_IMPORTED_MODULE_3__constants_login__["a" /* AREAS */],
      configType: 'common',
      area: __WEBPACK_IMPORTED_MODULE_3__constants_login__["a" /* AREAS */][0].value,
      phone: '',
      password: '',
      protocol: !1,
      passwordShowed: !0,
      validators: {},
      submitting: !1,
      searchObj: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_Russel__["Search2objFilter"])(location.search)
    };
  },

  computed: {
    config: function config() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.extend({}, __WEBPACK_IMPORTED_MODULE_3__constants_login__["b" /* default */].common, __WEBPACK_IMPORTED_MODULE_3__constants_login__["b" /* default */][this.configType]);
    },
    phoneRegex: function phoneRegex() {
      return (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3__constants_login__["a" /* AREAS */], { value: this.area }) || __WEBPACK_IMPORTED_MODULE_3__constants_login__["a" /* AREAS */][0]).regex;
    },
    phoneError: function phoneError() {
      return this.getError(this.validators.phone, {
        required: '请输入手机号',
        pattern: '请输入正确的手机号',
        exist: '手机号不存在',
        deleted: '手机号不存在'
      });
    },
    passwordError: function passwordError() {
      return this.getError(this.validators.password, {
        required: '请输入密码'
      });
    },
    formInvalid: function formInvalid() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(this.validators, function (item) {
        return !item.$valid;
      });
    },
    formattedSearch: function formattedSearch() {
      var searchObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.searchObj);
      if (this.phone) searchObj.phone = this.phone;
      if (this.area) searchObj.area = this.area;
      if (this.code) searchObj.code = this.code;
      if (this.protocol) searchObj.protocol = 1;
      return '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_Russel__["Obj2searchFilter"])(searchObj);
    }
  },
  methods: {
    togglePassword: function togglePassword() {
      this.passwordShowed = !this.passwordShowed;
    },
    generate: function generate() {
      this.configType = this.searchObj.config || 'common';
      this.phone = this.searchObj.phone || '';
      this.area = this.searchObj.area || '';
      this.code = this.searchObj.code || '';
      this.protocol = !!this.searchObj.protocol;
    },
    checkPhone: function checkPhone() {
      var areaCode = this.area.replace('+', '');

      return __WEBPACK_IMPORTED_MODULE_4__services_login__["a" /* default */].checkPhone(this.config.checkReq, { area_code: areaCode, phone: this.phone });
    },
    checkPhoneV2: function checkPhoneV2() {
      var areaCode = this.area.replace('+', '');

      return __WEBPACK_IMPORTED_MODULE_4__services_login__["a" /* default */].checkPhoneV2(this.config.checkReq, { area_code: areaCode, phone: this.phone });
    },
    checkProtocol: function checkProtocol() {
      return __WEBPACK_IMPORTED_MODULE_4__services_login__["a" /* default */].checkProtocol(this.config.protocolReq, { area_code: this.area, phone: this.phone });
    },
    getError: function getError(validator) {
      var rule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!validator || !validator.$touched || validator.$valid) return '';
      var error = void 0;
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(validator.$errors, function (item, key) {
        if (item) error = key;
        return item;
      });
      return rule[error] || '';
    },
    getFormInvalid: function getFormInvalid() {
      var _this = this;

      var formNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.some(formNames, function (name) {
        return _this.validators[name] && !_this.validators[name].$valid;
      });
    },
    goRegister: function goRegister() {
      location.href = location.origin + '/backend/register/' + this.formattedSearch;
    },
    goLogin: function goLogin() {
      location.href = location.origin + '/backend/login/' + this.formattedSearch;
    },
    goReset: function goReset() {
      location.href = location.origin + '/backend/reset/' + this.formattedSearch;
    }
  },
  components: {
    LgSelects: __WEBPACK_IMPORTED_MODULE_1__components_login_forms_selects__["a" /* default */],
    BackHome: __WEBPACK_IMPORTED_MODULE_2__components_back_home_back_home__["a" /* default */]
  },
  watch: {
    phone: function phone() {
      var _this2 = this;

      if (this.checkPhoneDisabled) return;
      this.$nextTick(function () {
        if (!_this2.validators.phone.$errors.pattern) {
          _this2.checkPhoneV2().then(function (_ref) {
            var exists = _ref.exists,
                deleted = _ref.deleted;

            _this2.validators.phone.$errors.exist = !exists;
            _this2.validators.phone.$errors.deleted = deleted;

            _this2.validators.phone.$valid = exists && !deleted;
          });
          _this2.checkProtocol().then(function (read) {
            if (read) _this2.protocol = !0;
          });
        }
      });
    }
  },
  created: function created() {
    this.generate();
    this.area = __WEBPACK_IMPORTED_MODULE_3__constants_login__["a" /* AREAS */][0].value;
  }
});

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_login__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      code: '',
      sended: !1,
      count: 60
    };
  },

  computed: {
    codeError: function codeError() {
      if (!this.getError && !this.validators) return '';
      return this.getError(this.validators.code, {
        required: '请输入验证码',
        number: '验证码应为数字'
      });
    },
    verifyInvalid: function verifyInvalid() {
      return this.sended || this.validators && this.validators.phone && !this.validators.phone.$valid;
    },
    verifyTxt: function verifyTxt() {
      return this.sended ? '\u5DF2\u53D1\u9001\uFF08' + this.count + '\uFF09' : '获取验证码';
    },
    trackEventOrigin: function trackEventOrigin() {
      switch (this.$options.name) {
        case 'Login':
          return 'web_login';
        case 'Reset':
          return 'web_reset';
        case 'Register':
          return 'web_register';
        case 'Bind':
          return 'web_bind';
        default:
          return '';
      }
    }
  },
  mounted: function mounted() {
    var self = this;

    new YpRiddler({
      expired: 2,
      mode: 'dialog',
      winWidth: 360,
      lang: 'zh-cn',
      container: document.getElementById('captchaBox'),
      appId: '3b13cf79ee5c47bebd0613030a15e440',
      version: 'v1',
      onError: function onError(param) {
        if (param.code === 429) {
          alert('请求过于频繁，请稍后再试！');
          return;
        }

        alert('验证服务异常');
      },
      onSuccess: function onSuccess(validInfo, close) {
        self.getVerifyCode(validInfo);
        close();
      },
      onFail: function onFail(code, msg, retry) {
        retry();
      },
      beforeStart: function beforeStart(next) {
        next();
      },
      onExit: function onExit() {}
    });
  },

  methods: {
    getVerifyCode: function getVerifyCode(validInfo) {
      if (this.verifyInvalid || !this.phone || this.sended) return !1;

      this.sended = !0;
      this.counter();

      return __WEBPACK_IMPORTED_MODULE_0__services_login__["a" /* default */].getVerifyCode({}, {
        area_code: this.area,
        phone: this.phone,
        authenticate: validInfo.authenticate,
        token: validInfo.token
      }).then(function (sucuessful) {
        if (!sucuessful) alert('获取验证码失败，请重试。');
      });
    },
    counter: function counter() {
      if (this.count > 0) {
        this.count -= 1;
        this.timer = setTimeout(this.counter, 1000);
      } else {
        this.count = 60;
        this.sended = !1;
        this.timer = null;
      }
    }
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_login__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Russel__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Russel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_Russel__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_Russel__["ValidateDirective"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('protocolFixer', __WEBPACK_IMPORTED_MODULE_4_Russel__["ProtocolFixerFilter"]);

var SENTRY_TEST_DSN = 'https://9b28a9eae15c448982e20ce7958a274a@sentry.qingchengfit.cn/12';
var SENTRY_PROD_DSN = 'https://6fd01b195c134689b1b5ba63debeacfb@sentry.qingchengfit.cn/11';

var DSN = location.host === 'cloud.qingchengfit.cn' ? SENTRY_PROD_DSN : SENTRY_TEST_DSN;

__WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.config(DSN).addPlugin(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__pages_login__["a" /* default */] }
});

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498864ff_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_home_vue__ = __webpack_require__(24);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(20)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-498864ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_498864ff_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/back_home/back_home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-498864ff", Component.options)
  } else {
    hotAPI.reload("data-v-498864ff", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selects_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1fe061_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selects_vue__ = __webpack_require__(23);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(19)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1fe061_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/login_forms/selects.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0f1fe061", Component.options)
  } else {
    hotAPI.reload("data-v-0f1fe061", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-lgSelects",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.toggle($event)
        }
      }
    },
    [
      _c("p", [
        _vm._v(_vm._s(_vm.current.name)),
        _c("i", {
          staticClass: "caret",
          class: { "caret-reverse": _vm.isOpen }
        })
      ]),
      _vm._v(" "),
      _vm.isOpen
        ? _c(
            "ul",
            _vm._l(_vm.selects, function(item) {
              return _c(
                "li",
                {
                  key: item.value,
                  class: { "z-active": item.value === _vm.current.value },
                  on: {
                    click: function($event) {
                      _vm.onSelect(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item.name))]
              )
            })
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f1fe061", esExports)
  }
}

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "m-backHome", attrs: { href: "/" } }, [
      _c("i", { staticClass: "icn icn-back" }),
      _vm._v(" "),
      _c("i", { staticClass: "txt" }, [_vm._v("返回首页")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-498864ff", esExports)
  }
}

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mini_tabs_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51d4819d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mini_tabs_vue__ = __webpack_require__(313);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(235)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51d4819d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mini_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51d4819d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mini_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/mini_tabs/mini_tabs.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51d4819d", Component.options)
  } else {
    hotAPI.reload("data-v-51d4819d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "m-miniTabs" },
    _vm._l(_vm.tabs, function(item) {
      return _c(
        "li",
        {
          key: item.vule,
          class: { "z-active": _vm.isActive(item) },
          on: {
            click: function($event) {
              _vm.setCurrent(item)
            }
          }
        },
        [_vm._v(_vm._s(item.name))]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51d4819d", esExports)
  }
}

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-login", attrs: { id: "app" } },
    [
      _c("back-home"),
      _vm._v(" "),
      _c("header", [
        _c("img", {
          attrs: { src: _vm._f("protocolFixer")(_vm.config.logo), alt: "" }
        }),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.config.title))])
      ]),
      _vm._v(" "),
      _c(
        "form",
        { staticClass: "m-loginForm", attrs: { name: "loginForm" } },
        [
          _c("mini-tabs", {
            staticClass: "tabs",
            attrs: { tabs: _vm.loginTypes },
            model: {
              value: _vm.loginType,
              callback: function($$v) {
                _vm.loginType = $$v
              },
              expression: "loginType"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item" },
            [
              _c("lg-selects", {
                staticClass: "select select-short",
                attrs: { selects: _vm.selects },
                model: {
                  value: _vm.area,
                  callback: function($$v) {
                    _vm.area = $$v
                  },
                  expression: "area"
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate:required",
                    arg: "required"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate:pattern",
                    value: _vm.phoneRegex,
                    expression: "phoneRegex",
                    arg: "pattern"
                  }
                ],
                staticClass: "input-short",
                attrs: {
                  type: "text",
                  placeholder: "请输入手机号",
                  name: "phone"
                },
                domProps: { value: _vm.phone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.phone = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.phoneError
                ? _c("p", { staticClass: "tip" }, [
                    _vm._v(_vm._s(_vm.phoneError))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loginType === "password",
                  expression: "loginType === 'password'"
                }
              ],
              staticClass: "item"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate:required",
                    arg: "required"
                  }
                ],
                attrs: {
                  type: "password",
                  placeholder: "请输入密码",
                  name: "password"
                },
                domProps: { value: _vm.password },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.passwordError
                ? _c("p", { staticClass: "tip" }, [
                    _vm._v(_vm._s(_vm.passwordError))
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loginType === "code",
                  expression: "loginType === 'code'"
                }
              ],
              staticClass: "item"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.code,
                    expression: "code"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate:required",
                    arg: "required"
                  }
                ],
                attrs: {
                  type: "text",
                  placeholder: "请输入验证码",
                  name: "code"
                },
                domProps: { value: _vm.code },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.code = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btnWrap", attrs: { id: "captchaBox" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class: { "z-disabled": _vm.verifyInvalid },
                      attrs: { type: "button", disabled: _vm.verifyInvalid }
                    },
                    [_vm._v(_vm._s(_vm.verifyTxt))]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.codeError
                ? _c("p", { staticClass: "tip" }, [
                    _vm._v(_vm._s(_vm.codeError))
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item item-left" }, [
            _c(
              "label",
              { staticClass: "checkbox", attrs: { for: "protocol" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.protocol,
                      expression: "protocol"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate:required",
                      arg: "required"
                    }
                  ],
                  attrs: { type: "checkbox", name: "protocol", id: "protocol" },
                  domProps: {
                    checked: Array.isArray(_vm.protocol)
                      ? _vm._i(_vm.protocol, null) > -1
                      : _vm.protocol
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.protocol,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.protocol = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.protocol = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.protocol = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("i", { staticClass: "icon-checkbox" }),
                _vm._v(" "),
                _vm._m(0)
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item f-cf" }, [
            _c(
              "button",
              {
                staticClass: "f-fl submitBtn",
                attrs: {
                  type: "submit",
                  disabled: _vm.formInvalid,
                  "data-action": "saTrack",
                  "data-event": "UnionLoginBtnClick",
                  "data-track-event-origin": "web"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [_vm._v("确认登录")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "linkWrap f-fr" }, [
              _c(
                "a",
                {
                  attrs: { href: "/backend/register/" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.goRegister($event)
                    }
                  }
                },
                [_vm._v("立即注册")]
              ),
              _vm._v("  |  "),
              _c(
                "a",
                {
                  attrs: { href: "/backend/reset/" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.goReset($event)
                    }
                  }
                },
                [_vm._v("忘记密码？")]
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("footer", [
        _c("p", { staticClass: "divide" }, [_vm._v("第三方账号登录")]),
        _vm._v(" "),
        _c("a", {
          staticClass: "icn icn-weixin",
          attrs: { href: _vm.weixinUri }
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "icn icn-work-weixin",
          attrs: { href: "/partner/work-weixin/user/auth/" }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _vm._v("我已阅读并同意"),
      _c("a", { attrs: { href: "/protocol/staff/", target: "_blank" } }, [
        _vm._v("《用户注册协议》")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c40149d6", esExports)
  }
}

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_axios__ = __webpack_require__(7);




var VerifyReq = '/api/send/verify/';

/* harmony default export */ __webpack_exports__["a"] = ({
  checkPhone: function checkPhone(checkReq) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].get(checkReq, { params: params }).then(function (event) {
      return event.data.exists;
    });
  },
  checkPhoneV2: function checkPhoneV2(checkReq) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].get(checkReq, { params: params }).then(function (event) {
      return event.data;
    });
  },
  checkProtocol: function checkProtocol(protocolReq) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].get(protocolReq, { params: params }).then(function (event) {
      return event.data.has_read_agreement;
    });
  },
  login: function login(loginReq) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].post(loginReq, data, { params: params }).then(function (event) {
      return event.data;
    });
  },
  reset: function reset(resetReq) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].post(resetReq, data, { params: params }).then(function (event) {
      return event.data;
    });
  },
  register: function register(registerReq) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].post(registerReq, data, { params: params }).then(function (event) {
      return event.data;
    });
  },
  checkBinding: function checkBinding(checkBindingReq) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].get(checkBindingReq, { params: params }).then(function (event) {
      return event.data.binding;
    });
  },
  bind: function bind(bindReq) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].post(bindReq, data, { params: params }).then(function (event) {
      return event.data;
    });
  },
  getVerifyCode: function getVerifyCode() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_axios__["a" /* default */].post(VerifyReq, data, { params: params }).then(function (event) {
      return event.data.success;
    });
  }
});

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.xsrfHeaderName = 'X-CSRFToken';
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.xsrfCookieName = 'csrftoken';
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = location.protocol + '//' + location.host;

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  if (config.method === 'post' || config.method === 'put') {
    config.headers['Content-Type'] = 'application/json';
  }

  return config;
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  var params = config.params || {};
  var url = config.url;
  url = url.replace(/\{(\/?)(\w+)\}/g, function (match, slash, key) {
    if (params[key]) {
      var value = params[key];
      delete params[key];
      return '' + (slash ? '/' : '') + (value || '');
    }
    return '';
  });

  config.url = url;
  config.params = params;
  return config;
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (resp) {
  if (resp.data.status === 200) {
    return resp.data;
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(resp.data.msg);
}, function (error) {
  if (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('unknown error');
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LgSelects',
  data: function data() {
    return {
      isOpen: !1,
      current: {}
    };
  },

  props: {
    value: {
      required: !0
    },
    selects: {
      required: !0,
      type: Array
    }
  },
  methods: {
    toggle: function toggle() {
      this.isOpen = !this.isOpen;
    },
    onSelect: function onSelect(item) {
      this.current = item;
      this.$emit('input', item.value);
    }
  },
  components: {},
  mixins: [],
  created: function created() {
    this.current = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.selects, { value: this.value }) || this.selects[0];
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MiniTabs',
  props: {
    value: {
      require: !0
    },
    tabs: {
      type: Array,
      require: !0
    }
  },
  methods: {
    setCurrent: function setCurrent(item) {
      this.$emit('input', item.value);
    },
    isActive: function isActive(item) {
      return item.value === this.value;
    }
  }
});

/***/ })

},[180]);


// WEBPACK FOOTER //
// js/loginApp.js